<template>
  <div class="page-knowledge">
    <div class="page-knowledge-cotent">
      <div class="page-knowledge-left">
        <el-input
          placeholder="目录名称"
          v-model="treeSearch"
          class="input-with-search"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="handleGetTreeData"
            style="cursor: pointer"
          ></i>
        </el-input>
        <el-tree
          ref="treeNode"
          v-if="auth.knowledgeMenu && auth.knowledgeMenu.toggleStatus"
          :data="knowTreeData"
          node-key="id"
          :default-expanded-keys="[currentKey]"
          :current-node-key="currentKey"
          :allow-drop="handleAllowDrop"
          @node-drag-end="handleDropEnd"
          @node-drop="handleDrop"
          @node-click="handleNodeClick"
          expand-on-click-node
          auto-expand-parent
          draggable
        >
          <div class="know-tree-node" slot-scope="{ node, data }">
            <span :title="data.label">{{ data.label }}</span>
            <span
              style="width:30px;"
              v-if="
                auth.knowledgeMenuInsert.toggleStatus ||
                  auth.knowledgeMenuUpdate.toggleStatus ||
                  auth.knowledgeMenuDelete.toggleStatus
              "
            >
              <el-dropdown
                @command="e => handleCommand(e, data)"
                v-if="node.isCurrent"
              >
                <span class="know-tree-setting" />
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="a"
                    v-if="
                      node.level < 3 &&
                        auth.knowledgeMenuInsert &&
                        auth.knowledgeMenuInsert.toggleStatus
                    "
                    >新建下级目录</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="b"
                    v-if="
                      node.level > 1 &&
                        auth.knowledgeMenuInsert &&
                        auth.knowledgeMenuInsert.toggleStatus
                    "
                    >新建平级目录</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="c"
                    divided
                    v-if="
                      node.level > 1 &&
                        auth.knowledgeMenuUpdate &&
                        auth.knowledgeMenuUpdate.toggleStatus
                    "
                    >编辑目录</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="d"
                    v-if="
                      node.level > 1 &&
                        auth.knowledgeMenuDelete &&
                        auth.knowledgeMenuDelete.toggleStatus
                    "
                    >删除目录</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </div>
        </el-tree>
      </div>
      <div class="page-knowledge-right">
        <!-- 搜索条 -->
        <div>
          <el-form
            ref="form"
            :inline="true"
            :model="search"
            style="position:relative;"
          >
            <el-form-item label="">
              <el-select v-model="search.orderType" @change="handleSearch()">
                <el-option
                  v-for="item in orderType"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-input
                placeholder="文档名称"
                v-model="search.docTitle"
                class="know-form-input"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="handleSearch"
                  style="cursor: pointer"
                ></i>
              </el-input>
            </el-form-item>
            <div style="position: absolute;right: 0;top: 5px;">
              <crm-button
                v-if="
                  auth.knowledgeDocInsert &&
                    auth.knowledgeDocInsert.toggleStatus
                "
                :buttonType="'secondary'"
                :text="'新增'"
                @click="handleAddDocument()"
              >
              </crm-button>
            </div>
          </el-form>
        </div>

        <!-- 客户列表 -->
        <el-table
          :data="
            auth.knowledgeDoc && auth.knowledgeDoc.toggleStatus
              ? knowListData && knowListData.results
              : []
          "
          border
          v-loading="loading"
          fit
          height="calc(100vh - 220px)"
          style="width: 100%"
        >
          <el-table-column
            show-overflow-tooltip
            label="文档"
            min-width="200"
            align="center"
            fixed="left"
          >
            <template slot-scope="{ row }">
              <span class="link" @click="toDetail(row)">
                <i class="know-doc-top" v-if="row.top === 1">置顶</i>
                <span>{{ row.docTitle }}</span>
                <i class="know-doc-reading" v-if="row.reading === 0"></i>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="modifiedUser"
            label="所有者"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="createTime"
            width="100"
            align="center"
            label="创建时间"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="modifiedTime"
            width="150"
            align="center"
            label="更新时间"
          >
          </el-table-column>
          <el-table-column
            prop="attachmentNumber"
            align="center"
            width="80"
            label="附件数"
          >
          </el-table-column>
          <el-table-column
            prop="readingCount"
            align="center"
            label="阅读量"
            width="80"
          >
          </el-table-column>
          <el-table-column
            width="100"
            align="center"
            label="操作"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <el-button
                v-if="
                  auth.knowledgeDocUpdate &&
                    auth.knowledgeDocUpdate.toggleStatus
                "
                @click="handleEditDocument(row)"
                type="text"
                size="small"
              >
                编辑
              </el-button>
              <el-button
                v-if="
                  auth.knowledgeDocDelete &&
                    auth.knowledgeDocDelete.toggleStatus
                "
                @click="handleDeleteDocument(row)"
                type="text"
                size="small"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 客户列表分页 -->
        <div class="pageination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagenation.pageNumber"
            :page-sizes="[10, 20, 50, 100, 200]"
            :page-size="pagenation.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="(knowListData && knowListData.totalCount) || 0"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增菜单 -->
    <el-dialog :title="menuForm.title" :visible.sync="menuForm.visible">
      <el-form :model="menuForm" ref="menuForm">
        <el-form-item
          label="目录名称"
          prop="menuName"
          :label-width="menuForm.formLabelWidth"
          :rules="[
            { required: true, message: '请输入目录名称', trigger: 'blur' },
            { max: 20, message: '最多20个字', trigger: 'change' },
            {
              validator: (rule, value, callback) => {
                const containSpecial = /[`~!@#$^*=|{}':;',\[\]\<\>\/?~！@#￥……*|{}‘；：'。，、？]/;
                if (containSpecial.test(value)) {
                  callback('目录名称不能包含特殊字符');
                }
                callback();
              },
              trigger: 'change',
            },
          ]"
        >
          <el-input
            v-model="menuForm.menuName"
            autocomplete="off"
            placeholder="请输入目录名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="上级目录" :label-width="menuForm.formLabelWidth">
          <el-cascader
            :options="knowTreeData"
            :show-all-levels="false"
            :props="{
              checkStrictly: true,
              emitPath: false,
            }"
            v-model="menuForm.parentId"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="menuForm.visible = false">取 消</el-button>
        <el-button type="primary" @click="handleDialogSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <add-document
      :item="docForm.selectedItem"
      :visible="docForm.visible"
      :type="docForm.type"
      @close="handleCloseAddDocument"
      @success="handleSearch()"
    />
    <detail
      v-if="detail.visible"
      :id="detail.detailId"
      :visible="detail.visible"
      @close="detail.visible = false"
      @refresh="handleGetListData()"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CrmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';
import AddDocument from '@/components/business/knowledge/addDocument';
import Detail from '@/components/business/knowledge/detail';
import service from '~api/knowledge';

export default {
  components: {
    CrmPanel,
    crmButton,
    AddDocument,
    Detail,
  },
  data() {
    return {
      loading: false,
      // 当前选中的菜单节点
      currentKey: '0',
      isDrag: true,
      detail: {
        visible: false,
        detailId: '',
        row: {},
      },
      treeSearch: '',
      search: {
        menuId: '0',
        docTitle: '',
        id: '',
        orderType: 'gmt_modified',
        pageNumber: 1,
        pageSize: 10,
      },
      pagenation: {
        pageSize: 10,
        pageNumber: 1,
      },
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      orderType: [
        {
          label: '创建时间排序',
          value: 'gmt_created',
        },
        {
          label: '更新时间排序',
          value: 'gmt_modified',
        },
        {
          label: '阅读量排序',
          value: 'reading_count',
        },
      ],
      // 菜单表单
      menuForm: {
        title: '新建目录',
        visible: false,
        selectItem: {},
        formLabelWidth: '120px',
        menuName: '',
        parentId: '',
        id: '0',
      },
      docForm: {
        type: 'add',
        visible: false,
        selectItem: {},
        id: '',
      },
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      textStatus: '',
      knowTreeData: [],
      textArr: [
        '您没有权限！',
        '不能移动至顶级目录!',
        '不能移动至四级目录!',
        '带有子级目录的二级目录不能移动成三级目录!',
      ],
    };
  },
  watch: {
    treeSearch: {
      handler: 'handleGetTreeData',
    },
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      knowListData: 'knowledge/knowListData',
    }),
  },
  created() {
    this.handleGetTreeData();
    this.handleGetListData();
  },
  methods: {
    ...mapActions({
      getKnowData: 'knowledge/getKnowData',
      getTreeData: 'knowledge/getTreeData',
      addMenu: 'knowledge/addMenu',
      editMenu: 'knowledge/editMenu',
      deleteMenu: 'knowledge/deleteMenu',
      moveMenu: 'knowledge/moveMenu',
      deleteKnowDoc: 'knowledge/deleteKnowDoc',
    }),
    toDetail(row) {
      this.detail.visible = true;
      this.detail.detailId = row.id;
      this.detail.row = row;
    },
    handleEditDocument(row) {
      this.docForm.type = 'edit';
      this.docForm.visible = true;
      this.docForm.selectedItem = row;
    },
    handleDeleteDocument(row) {
      this.$confirm('此操作将永久删除该文档, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteKnowDoc({ id: row.id })
            .then(() => {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.handleGetListData();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    handleAddDocument() {
      this.docForm.type = 'add';
      this.docForm.visible = true;
      this.docForm.selectedItem = {
        menuId: this.menuForm.id,
      };
    },
    handleParams(data) {
      return {
        ...this.search,
        ...data,
      };
    },
    handleSearch() {
      this.pagenation.pageNumber = 1;
      this.handleGetListData();
    },
    async handleGetTreeData() {
      await service
        .apiGetTreeData({
          menuName: this.treeSearch,
        })
        .then((res) => {
          const loop = (data, level) =>
            data.filter((v) => {
              v.label = v.menuName;
              v.value = v.id;
              v.is_shown = false;
              v.is_level = level;
              if (v.childrenList.length > 0) {
                const arr = loop(v.childrenList, level + 1);
                v.children = arr.sort((a, b) => a.menuOrder < b.menuOrder);
              }
              return level < 3;
            });

          if (res.data) {
            if (res.data.data === null) {
              const value = {
                label: '全部文档',
                value: '0',
                parentId: '',
                id: '0',
                menuName: '全部文档',
                menuOrder: 0,
                is_shown: false,
                is_level: 0,
                children: [],
              };
              this.knowTreeData = [value];
            } else {
              loop(res.data.childrenList, 1);
              const result = [
                {
                  label: res.data.menuName,
                  value: res.data.id,
                  id: res.data.id,
                  menuOrder: res.data.menuOrder,
                  parentId: res.data.parentId,
                  is_shown: false,
                  is_level: 0,
                  children: res.data.childrenList,
                },
              ];
              this.knowTreeData = result;
            }
          }
        });
    },
    handleGetListData() {
      this.loading = true;

      this.getKnowData({
        ...this.search,
        ...this.pagenation,
      })
        .then(() => {
          const list = this.knowListData.results
            ? this.knowListData.results.length
            : 0;
          if (list === 0 && this.pagenation.pageNumber !== 1) {
            this.pagenation.pageNumber = 1;
            this.handleGetListData();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleDropstart() {
      this.textStatus = '';
    },
    handleAllowDrop(draggingNode, dropNode, type) {
      if (!this.auth.knowledgeMenuMove.toggleStatus) {
        this.textStatus = 0;
        return false;
      }
      if (dropNode.data.id === '0') {
        this.textStatus = 1;
        return false;
      }
      if (dropNode.level === 3) {
        this.textStatus = 2;
        return false;
      }

      if (
        draggingNode.level === 2
        && draggingNode.childNodes.length !== 0
        && type === 'inner'
      ) {
        this.textStatus = 3;
        return false;
      }
      this.textStatus = '';

      return true;
    },
    handleDropEnd(draggingNode, dropNode, dropType, ev) {
      if (this.textStatus) {
        this.$message({
          type: 'warning',
          message: `${this.textArr[this.textStatus]}`,
        });
      }
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      this.moveMenu({
        id: draggingNode.data.id,
        menuName: draggingNode.data.menuName,
        parentId:
          dropType === 'inner' ? dropNode.data.id : dropNode.data.parentId,
        menuOrder:
          dropType === 'after'
            ? dropNode.data.menuOrder + 1
            : dropNode.data.menuOrder,
      })
        .then(() => {
          this.handleGetTreeData();
        })
        .catch(() => {
          /**
           * 权限范围是个人的时候，移动非当前登陆人创建的目录，后端会抛异常 前端重新刷新页面
           */
          this.handleGetTreeData();
        });
    },
    handleNodeClick(item, node, element) {
      this.currentKey = item.id;
      this.menuForm.selectItem = item;
      this.menuForm.id = item.id;
      this.search.menuId = item.id;
      this.handleGetListData();
    },
    handleCommand(command, data) {
      switch (command) {
        case 'a':
          this.handleCreateChildMenu(data);
          break;
        case 'b':
          this.handleCreateNextMenu(data);
          break;
        case 'c':
          this.handleEditMenu(data);
          break;
        case 'd':
          this.handleDeleteMenu(data);
          break;
        default:
          break;
      }
    },
    handleCreateChildMenu(data) {
      this.menuForm.title = '新建目录';
      this.menuForm.visible = true;
      this.menuForm.parentId = data.id;
    },
    handleCreateNextMenu(data) {
      this.menuForm.title = '新建目录';
      this.menuForm.visible = true;
      this.menuForm.parentId = data.parentId;
    },
    handleEditMenu(data) {
      this.menuForm.title = '编辑目录';
      this.menuForm.visible = true;
      this.menuForm.id = data.id;
      this.menuForm.parentId = data.parentId;
      this.menuForm.menuName = data.menuName;
    },
    handleDeleteMenu(data) {
      if (!this.knowListData.results.length) {
        this.$confirm('是否确认删除该目录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.handleDeleteKnowledgeMenu(data.id);
          })
          .catch(() => {});
      } else {
        this.$confirm('该目录下有文档，请将文档移出后重试', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            // this.handleDeleteKnowledgeMenu(data.id)
          })
          .catch(() => {});
      }
    },
    handleDeleteKnowledgeMenu(id) {
      this.deleteMenu({ id })
        .then(() => {
          this.handleGetTreeData();
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;
      this.handleGetListData();
    },
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetListData();
    },
    handleDialogSubmit() {
      this.$refs.menuForm.validate((valid) => {
        if (valid) {
          if (this.menuForm.title === '新建目录') {
            this.addMenu({
              menuName: this.menuForm.menuName,
              parentId: this.menuForm.parentId,
            }).then(() => {
              this.$message({
                type: 'success',
                message: '新增成功!',
              });
              this.menuForm.visible = false;
              this.menuForm.menuName = '';
              this.menuForm.parentId = '';
              this.treeSearch = '';
              this.handleGetTreeData();
            });
          }
          if (this.menuForm.title === '编辑目录') {
            this.editMenu({
              id: this.menuForm.id,
              menuName: this.menuForm.menuName,
              parentId: this.menuForm.parentId,
            }).then((result) => {
              this.$message({
                type: 'success',
                message: '编辑成功!',
              });
              this.menuForm.visible = false;
              this.menuForm.menuName = '';
              this.menuForm.parentId = '';
              this.treeSearch = '';
              this.handleGetTreeData();
            });
          }
          return true;
        }
        return false;
      });
    },
    handleCloseAddDocument() {
      this.docForm.visible = false;
      this.docForm.selectedItem = {};
      this.docForm.id = '';
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/const.less';

.page-knowledge {
  overflow: hidden;
  flex: 1;
  .page-knowledge-cotent {
    display: flex;
    flex: 1;
    width: 100%;
    height: calc(100vh);
  }
}

.page-knowledge-left {
  width: 200px;
  height: 100%;
  background-color: #fff;
  box-shadow: 0px 4px 20px 0px rgba(41, 36, 80, 0.2);
  border-radius: 4px;
  margin-right: 20px;
  .input-with-search {
    width: 180px;
    height: 40px;
    margin: 17px 10px 20px;
    background-color: #fff;
  }
  .el-tree {
    height: calc(100% - 180px);
    overflow-y: auto;
  }
  .el-tree-node__content {
    font-size: 12px;
    font-family: 'PingFang-SC-Medium,PingFang-SC';
    font-weight: 500;
    color: rgba(14, 21, 59, 1);
    height: 40px;
  }
  .el-tree-node__content:hover {
    background: rgba(206, 214, 254, 1);
    color: blue;
    .know-tree-node .el-dropdown {
      display: inline-block !important;
    }
  }
  .is-current > .el-tree-node__content {
    background: rgba(206, 214, 254, 1);
  }
  .know-tree-node {
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    overflow: hidden;
    & > span:first-child {
      flex: 1;
      padding: 2px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .know-tree-setting {
    display: inline-block;
    width: 12px;
    height: 12px;
    background: url('../../images/icon/icon_setting.png') center center;
    margin-left: 15px;
  }
}

.page-knowledge-right {
  width: 100%;
  background-color: #fff;
  padding: 20px;
  overflow: auto;
  .know-form-input {
    width: 400px;
  }
  .know-doc-top {
    display: inline-block;
    width: 40px;
    height: 20px;
    background: rgba(255, 120, 120, 1);
    border-radius: 12px;
    font-size: 12px;
    font-family: 'PingFangSC-Regular,PingFang SC';
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 20px;
    font-style: normal;
  }
  .know-doc-reading {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: rgba(255, 120, 120, 1);
    border-radius: 6px;
  }
}
.el-dropdown-menu .el-dropdown-menu__item:focus,
.el-dropdown-menu .el-dropdown-menu__item:not(.is-disabled):hover {
  background: #ecf5ff;
  color: #66b1ff;
}
.el-dropdown-menu .el-dropdown-menu__item {
  cursor: pointer;
}
</style>
